import { FileFieldContext } from '@main/dynamic-form-fields';
import { QuestionnaireUploadFragment } from '@main/graphql/fragments/QuestionnaireUploadFragment.generated';
import { FileUpload, useDownloadStorageFile, useEagerFileUpload } from '@main/ui';
import { useContext } from 'react';

export interface QuestionnaireFieldSupportingFileProps {
  supportingFile: QuestionnaireUploadFragment;
}

export function QuestionnaireFieldSupportingFile({
  supportingFile,
}: QuestionnaireFieldSupportingFileProps) {
  const { questionSupportingFile } = useContext(FileFieldContext);
  const supportingFileUpload = useEagerFileUpload({
    onFileDownload: useDownloadStorageFile(),
    file: supportingFile.file,
  });

  return (
    <FileUpload {...supportingFileUpload} {...questionSupportingFile}>
      <FileUpload.Files />
      <FileUpload.Dropzone />
    </FileUpload>
  );
}
